import React from 'react';


const logopath = '';
const HotelLogo = (props) => {
    const {
        imageName = '', className = '', altText = '',
    } = props;
    return (
        <img src={`${logopath}/${imageName}`} className={className} alt={`${altText}`} />
    );
}

export default HotelLogo;